/**
 * @param {Object} product - product data
 * @returns {string} product suggestion HTML
 */
export default product =>
    `<li class="product-suggestion"
        data-cnstrc-item-section="Products"
        data-cnstrc-item-name="${product.parentName}"
        data-cnstrc-item-id="${product.ID}"
        >
        <a class="product-link" href="${product.url}" aria-label="${product.parentName}" tabindex="0">
            <span class="product-image">
                <img src="${product.image.url}" alt="${product.image.alt}" title="${product.image.title}" />
            </span>
            <span class="product-details">
                <span class="xlt-pdpName product-name">
                    ${
                        product.additionalInfo?.isSet === true
                            ? `
                        <span class="product-name-inner">
                            <span class="product-modelname"> ${product.parentName} </span
                        </span>
                    `
                            : `
                    <span class="product-name-inner">
                        ${product.modelName ? `<span class="product-modelname"> ${product.modelName} </span>` : ''}
                        ${product.shortName ? `<span class="product-shortname"> ${product.shortName} </span>` : ''}
                    </span>
                    ${
                        product.colorName
                            ? `
                            <span class="product-colorname">
                                <span class="label"> ${window.Resources.PRODUCT_COLOR_LABEL}: </span> ${product.colorName}
                            </span>
                            `
                            : ''
                    }
                            `
                    }
                </span>
                <span class="xlt-pdpPrice product-price">
                    ${
                        product.priceInfo && product.priceInfo.showFrom
                            ? `<span class="from">
                                ${window.Resources.SHOW_FROM}
                            </span>${product.priceInfo.minPrice}`
                            : product.priceInfo.minPrice
                    }
                </span>
            </span>
        </a>
    </li>`;
